import type { Fraction, Numeric } from './types';
import { isFraction } from './types';

export function asBool(value: unknown): boolean {
  let val = false;

  if (typeof value === 'string') {
    val = value.toLowerCase() == 'true' || Number(value) == 1 ? true : false;
  }

  if (typeof value === 'number') {
    val = value == 1 ? true : false;
  }

  if (typeof value === 'boolean') {
    val = value;
  }

  return val;
}

export function asInt(value: unknown): number {
  if (typeof value === 'number') {
    return Math.floor(value);
  }
  if (typeof value === 'string') {
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? 0 : parsed;
  }
  return 0;
}

/**
 * Parse `value` as an integer, returning `def` (default `0`) when the
 * value cannot be parsed. Mirrors the legacy `Calculator.getInt` global.
 */
export function getInt(value: unknown, def = 0): number {
  const parsed = parseInt(value as string, 10);
  return isNaN(parsed) ? def : parsed;
}

/**
 * Returns true if the value is a finite number or a valid fraction.
 */
export function isNumber(value: unknown): value is number | Fraction {
  if (isFraction(value as Numeric)) {
    const f = value as Fraction;
    return isNumber(f[0]) && isNumber(f[1]);
  }
  return isFinite(value as number);
}
